import { useQueryClient } from '@tanstack/react-query';
import { useCreateWorkflow } from 'api';
import type { CreateWorkflowBody, PlanType } from 'api/models';
import classNames from 'classnames/bind';
import { useHistory, useRouteMatch } from 'react-router';
import { PAYMENT_WORKFLOWS_QUERY_KEY } from '../api';

import { WorkflowForm } from './WorkflowForm';
import styleIdentifiers from './WorkflowForm.module.scss';
import { formatValues } from './WorkflowForm.utils';

const styles = classNames.bind(styleIdentifiers);

export const WorkflowFormAdd = () => {
  const {
    params: { planType },
  } = useRouteMatch<{ planType: PlanType }>();
  const history = useHistory();
  const queryClient = useQueryClient();

  const { mutate: createWorkflow, isPending } = useCreateWorkflow();

  const onSubmit = (data: CreateWorkflowBody) =>
    createWorkflow(
      { data: formatValues(data) },
      {
        onSuccess: response => {
          queryClient.invalidateQueries({ queryKey: ['templates'] });
          queryClient.invalidateQueries({ queryKey: PAYMENT_WORKFLOWS_QUERY_KEY });
          history.push(`/settings/workflows/${planType}/edit/${response.data.id}`);
        },
      },
    );

  return (
    <div className={styles('workflows-add')}>
      <WorkflowForm planType={planType} onSubmit={onSubmit} isLoading={isPending} />
    </div>
  );
};
